/* ─────────────────────────────────────────────────────────
   PEAKVIEW · CONSENT MODULE
   Public API for analytics integrations to gate on user consent.

   Storage key  : pv_cookie_consent_v1
   Stored values: 'accepted' | 'declined' | null (not decided)

   Example use (in a future analytics script):
     PeakViewConsent.onConsent(function () {
       // initialize analytics here — only runs after ACCEPT
     });

   The module is intentionally inert on its own. The companion banner
   (snippets/cookie-banner.liquid + the controller appended to this
   file when the banner ships) is what dispatches the
   peakview:consent-granted and peakview:consent-declined events.
   ───────────────────────────────────────────────────────── */
(function () {
  var STORAGE_KEY = 'pv_cookie_consent_v1';

  function read() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  window.PeakViewConsent = {
    STORAGE_KEY: STORAGE_KEY,

    hasConsent: function () {
      return read() === 'accepted';
    },

    hasDeclined: function () {
      return read() === 'declined';
    },

    onConsent: function (callback) {
      if (typeof callback !== 'function') return;
      if (window.PeakViewConsent.hasConsent()) {
        callback();
        return;
      }
      window.addEventListener('peakview:consent-granted', callback, { once: true });
    },

    reset: function () {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      window.location.reload();
    }
  };
})();


/* ─────────────────────────────────────────────────────────
   COOKIE BANNER CONTROLLER
   Internal — paired with snippets/cookie-banner.liquid.
   Shows the banner 1200ms after page load when no consent decision
   is stored, binds ACCEPT / DECLINE buttons, dispatches the events
   PeakViewConsent listeners are waiting on, and removes the banner
   from the DOM after the slide-out transition completes.

   Supports a ?reset-cookies=true URL parameter that clears stored
   consent (used as the no-JS fallback for the footer "Cookie
   preferences" link) and then strips the param from the URL so it
   isn't carried into shared links or browser history.
   ───────────────────────────────────────────────────────── */
(function () {
  var STORAGE_KEY = 'pv_cookie_consent_v1';
  var BANNER_ID = 'pv-cookie-banner';
  var SHOW_DELAY_MS = 1200;
  var HIDE_TRANSITION_MS = 700;

  function getBanner() {
    return document.getElementById(BANNER_ID);
  }

  function readStored() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStored(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
  }

  function handleResetUrlParam() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('reset-cookies') !== 'true') return;
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      params.delete('reset-cookies');
      var qs = params.toString();
      var cleanUrl = window.location.pathname
        + (qs ? '?' + qs : '')
        + window.location.hash;
      window.history.replaceState({}, '', cleanUrl);
    } catch (e) {}
  }

  function show() {
    var banner = getBanner();
    if (!banner) return;
    window.setTimeout(function () {
      banner.setAttribute('data-state', 'visible');
    }, SHOW_DELAY_MS);
  }

  function hideAndRemove() {
    var banner = getBanner();
    if (!banner) return;
    banner.setAttribute('data-state', 'hidden');
    window.setTimeout(function () {
      if (banner.parentNode) banner.parentNode.removeChild(banner);
    }, HIDE_TRANSITION_MS);
  }

  function removeImmediately() {
    var banner = getBanner();
    if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
  }

  function bindButtons() {
    var banner = getBanner();
    if (!banner) return;
    banner.addEventListener('click', function (e) {
      var target = e.target.closest('[data-consent]');
      if (!target) return;
      var decision = target.getAttribute('data-consent');
      if (decision !== 'accept' && decision !== 'decline') return;

      writeStored(decision === 'accept' ? 'accepted' : 'declined');

      var eventName = decision === 'accept'
        ? 'peakview:consent-granted'
        : 'peakview:consent-declined';
      window.dispatchEvent(new CustomEvent(eventName));

      hideAndRemove();
    });
  }

  function init() {
    handleResetUrlParam();
    var stored = readStored();
    if (stored === 'accepted' || stored === 'declined') {
      removeImmediately();
      return;
    }
    bindButtons();
    show();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
